import { Stack, Typography } from "@mui/material";
import OutlinedSelectButton from "../../../../Components/SelectionButton";
import { useFormikContext } from "formik";
import { BorderBox } from "../../../../Helpers/Helpers";
import CustomOptions from "../../../../Components/CustomOptionsButton";

const DisplaySettings = () => {
    const displayFormate = [
        {
            displayKey: "Default",
            value: "default"
        },
        {
            displayKey: "Upper",
            value: "upper"
        },
        {
            displayKey: "Lower",
            value: "lower"
        }
    ];
    const showNegativeFigures = [
        {
            displayKey: "Normal",
            value: "normal"
        },
        {
            displayKey: "Parantheses",
            value: "parantheses"
        },
        {
            displayKey: "With a trail Minus",
            value: "withATrailMinus"
        }
    ];

    const showNegtaiveFiguresInRed = {
        displayKey: "Show Negtaive figures in Red",
        value: "showNegtaiveFiguresInRed"
    };

    const showAccounts = [
        {
            displayKey: "Don't Show No transaction accounts",
            value: "don'tShowNoTransactionAccounts"
        },
        {
            displayKey: "Don't Show nullified accounts",
            value: "don'tShowNullifiedAccounts"
        },
        {
            displayKey: "Hide Account Code",
            value: "hideAccountCode"
        }
    ]
    const showFigures = [
        {
            displayKey: "Divided by 1000",
            value: "dividedBy1000"
        },
        {
            displayKey: "Without cents",
            value: "withOutCents"
        },
        {
            displayKey: "Exclude Zero Values",
            value: "excludeZeroValues"
        }
    ];

    const viewReport = {
        displayKey: "Show report in full view",
        value: "showReportInFullView"
    };


    const { values, handleChange, setFieldValue } = useFormikContext();

    return (
        <Stack height={"100%"} width={"100%"} gap={5}>

            <Stack direction={"row"} gap={3} alignItems={"center"} >
                <Typography fontSize={12}>
                    Display text format
                </Typography>

                {displayFormate.map(item =>
                    <OutlinedSelectButton
                        key={item.displayKey}
                        label={item.displayKey}
                        selected={values.display.displayText === item.value}
                        onClick={() =>
                            setFieldValue("display.displayText", item.value)
                        }
                        width="150px"
                    />
                )}
            </Stack>
            <Stack direction={"row"} gap={2} height={"100%"}>
                <Stack gap={1} height={"100%"} width={"60%"}>
                    <BorderBox direction={"row"} gap={1} flexWrap={"wrap"} height={"40%"} alignItems={"center"}>

                        <Typography fontSize={12}>
                            Show Negative Figures
                        </Typography>

                        {showNegativeFigures.map(item =>
                            <OutlinedSelectButton
                                key={item.displayKey}
                                label={item.displayKey}
                                selected={values.display.negativeFigures.formate === item.value}
                                onClick={() =>
                                    setFieldValue("display.negativeFigures.formate", item.value)
                                }
                                width={item.value === "withATrailMinus" ? "150px" : "120px"}
                            />
                        )}
                        {/* <CustomOptions
                            key={showNegtaiveFiguresInRed.displayKey}
                            type={showNegtaiveFiguresInRed.displayKey}
                            selected={
                                values.display.negativeFigures.colour === showNegtaiveFiguresInRed.value
                            }
                            onClick={() => {
                                const isSelected =
                                    values.display.negativeFigures.colour === showNegtaiveFiguresInRed.value;

                                setFieldValue(
                                    "display.negativeFigures.colour",
                                    isSelected ? null : showNegtaiveFiguresInRed.value
                                );
                            }}
                            width="250px"
                        /> */}

                        <CustomOptions
                            key={showNegtaiveFiguresInRed.displayKey}
                            type={showNegtaiveFiguresInRed.displayKey}
                            selected={values.display.negativeFigures.colour}
                            onClick={() => {
                                setFieldValue(
                                    "display.negativeFigures.colour",
                                    !values.display.negativeFigures.colour
                                );
                            }}
                            width="250px"
                        />


                    </BorderBox>
                    <BorderBox
                        flexWrap={"wrap"}
                        height={"60%"}
                        justifyContent={"center"}
                        gap={5}
                        direction={"row"}
                        alignContent={"center"}
                    >

                        <Typography fontSize={12} textAlign={"left"}>
                            Show accounts
                        </Typography>
                        <Stack direction={"column"} gap={3} flexWrap={"wrap"} alignItems={"center"}>
                            {showAccounts.map(item =>

                                <CustomOptions
                                    key={item.displayKey}
                                    type={item.displayKey}
                                    selected={values.display.showAccounts.includes(item.value)}
                                    onClick={() => {
                                        const current = values.display.showAccounts;

                                        if (current.includes(item.value)) {
                                            setFieldValue(
                                                "display.showAccounts",
                                                current.filter(val => val !== item.value)
                                            );
                                        } else {
                                            setFieldValue(
                                                "display.showAccounts",
                                                [...current, item.value]
                                            );
                                        }
                                    }}

                                    width="250px"
                                />
                            )}

                        </Stack>

                    </BorderBox>

                </Stack>

                <Stack p={0} gap={1} height={"100%"} width={"40%"}>
                    <BorderBox
                        flexWrap={"wrap"}
                        height={"100%"}
                        justifyContent={"center"}
                        gap={2}
                        direction={"row"}
                        alignContent={"center"}
                    >
                        <Typography fontSize={12}>
                            Show Figures
                        </Typography>
                        <Stack direction={"column"} gap={3} flexWrap={"wrap"} alignItems={"center"}  >

                            {showFigures.map(item =>

                                <CustomOptions
                                    key={item.displayKey}
                                    type={item.displayKey}
                                    selected={values.display.showFigures.includes(item.value)}
                                    onClick={() => {
                                        const current = values.display.showFigures;

                                        setFieldValue(
                                            "display.showFigures",
                                            current.includes(item.value)
                                                ? current.filter(v => v !== item.value)
                                                : [...current, item.value]
                                        );
                                    }}
                                // width="250px"
                                />
                            )}

                        </Stack>

                    </BorderBox>
                    <BorderBox
                        flexWrap={"wrap"}
                        height={"100%"}
                        justifyContent={"center"}
                        gap={2}
                        alignItems={"center"}
                        direction={"row"}
                    >
                        <Typography fontSize={12} textAlign={"left"}>
                            View report
                        </Typography>
                        <CustomOptions
                            key={viewReport.displayKey}
                            type={viewReport.displayKey}
                            selected={
                                values.display.viewReport === viewReport.value
                            }
                            onClick={() => {
                                const isSelected =
                                    values.display.viewReport === viewReport.value;

                                setFieldValue(
                                    "display.viewReport",
                                    isSelected ? null : viewReport.value
                                );
                            }}
                            width="250px"
                        />
                    </BorderBox>
                </Stack>

            </Stack>



        </Stack>
    )
};

export default DisplaySettings;